/** Token Super Admin — localStorage + redirect su 401. */

const ADMIN_TOKEN_KEY = "6amico_admin_token";
const SESSION_EXPIRED_MSG = "Sessione scaduta — esci e rientra in Super Admin (/admin)";

export function isValidAdminToken(token) {
  const t = (token ?? "").toString().trim();
  return Boolean(t) && t !== "null" && t !== "undefined";
}

export function getAdminToken() {
  if (typeof localStorage === "undefined") return "";
  const t = localStorage.getItem(ADMIN_TOKEN_KEY) || "";
  return isValidAdminToken(t) ? t : "";
}

export function setAdminToken(token) {
  if (typeof localStorage === "undefined") return;
  if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
  else localStorage.removeItem(ADMIN_TOKEN_KEY);
}

export function clearAdminToken() {
  setAdminToken("");
}

export function adminAuthHeaders() {
  const t = getAdminToken();
  return t ? { headers: { Authorization: `Bearer ${t}` } } : {};
}

/** Header piatto per axios.post/get diretti: { Authorization: 'Bearer …' } */
export function getAdminAuthHeaders() {
  const t = getAdminToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

/** Block save/upload when token missing or stale (Bearer null). */
export function requireAdminSession() {
  const t = getAdminToken();
  if (!isValidAdminToken(t)) {
    return { ok: false, message: SESSION_EXPIRED_MSG };
  }
  return { ok: true, token: t };
}

export function formatAdminSaveError(error, fallback = "Errore operazione") {
  const status = error?.response?.status;
  if (status === 401) {
    return "Sessione scaduta — esci e rientra in Super Admin (/admin)";
  }
  if (status === 502 || status === 503 || status === 504) {
    return "Server momentaneamente non raggiungibile — attendi 10 secondi e riprova";
  }
  if (status === 500) {
    return "Errore server (500) — riprova tra poco; se persiste segnala al supporto tecnico";
  }
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") {
    if (detail === "Invalid token" || detail === "Missing token") {
      return "Sessione scaduta — esci e rientra in Super Admin (/admin)";
    }
    return detail;
  }
  if (Array.isArray(detail)) return detail.map((x) => x.msg || x).join("; ");
  return error?.message || fallback;
}

function isAdminAuthEndpoint(url = "") {
  return /\/admin\/(auth|login)(\/|$|\?)/.test(url);
}

/** True se la risposta 401 admin è stata gestita (token rimosso + redirect). */
export function handleAdminAuthError(error) {
  const status = error?.response?.status;
  const url = error?.config?.url || "";
  if (status !== 401 || !url.includes("/admin/") || isAdminAuthEndpoint(url)) {
    return false;
  }
  if (!getAdminToken()) return false;

  clearAdminToken();

  if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) {
    const next = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.assign(`/admin?tab=comuni&next=${next}&session=expired`);
  }
  return true;
}

export async function verifyAdminToken() {
  const token = getAdminToken();
  if (!token) return false;
  try {
    const axios = (await import("axios")).default;
    const { API } = await import("../api");
    await axios.get(`${API}/admin/settings`, {
      headers: { Authorization: `Bearer ${token}` },
      timeout: 8000,
    });
    return true;
  } catch {
    clearAdminToken();
    return false;
  }
}
